export default __webpack_public_path__ + "static/archrings-a3bfe22828e5f660ea196118a4b5cdc5.png";